import { render, staticRenderFns } from "./LayoutThemeModal.vue?vue&type=template&id=b72afb12&scoped=true"
import script from "./LayoutThemeModal.vue?vue&type=script&lang=js"
export * from "./LayoutThemeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72afb12",
  null
  
)

export default component.exports